// import AnimatedLineContent from "@components/animated-line-content";
import Grid from '@components/grid';
import PartnerItem from '@components/partner-item';
import Carousel from '@components/ui/carousel/carousel';
import Container from '@components/ui/container';
import Text from '@components/ui/text';
import { useInView } from 'react-intersection-observer';
import React, { ReactElement } from 'react';
import { IoMdReturnRight } from 'react-icons/io';
import { SwiperSlide } from 'swiper/react';

const partnersResponsive = {
  '1500': {
    slidesPerView: 6,
    spaceBetween: 34,
  },
  '1280': {
    slidesPerView: 5,
    spaceBetween: 28,
  },
  '768': {
    slidesPerView: 4,
    spaceBetween: 24,
  },
  '480': {
    slidesPerView: 3,
    spaceBetween: 20,
  },
  '0': {
    slidesPerView: 2,
    spaceBetween: 12,
  },
};

export default function PartnerLogoSlider(block: any): ReactElement {
  const {
    title = 'Out partners',
    // subTitle = "Trusted by Tier One telecom providers.",
    description = "Our support systems and applications provide network protection for the world's largest telecom providers.",
    logos,
  } = block;

  const { ref } = useInView({
    threshold: 0.4,
  });

  return (
    <Container>
      <div ref={ref}>
        <Grid className="py-8 md:py-12 lg:py-20">
          <div className="w-full h-full col-span-full md:col-span-4">
            <div className="flex flex-col justify-start items-start relative pt-6">
              <div className="col-span-full md:col-span-4 lg:col-span-8 mb-4 flex relative justify-start items-center">
                <IoMdReturnRight className="mr-1 text-black" />
                <Text variant="subHeading" className="max-w-md text-left">
                  {title}
                </Text>
              </div>
              <Text className="max-w-md mt-2">{description}</Text>
            </div>
          </div>

          <div className="heightFull col-span-full w-full">
            <Carousel
              breakpoints={partnersResponsive}
              buttonSize="small"
              autoplay={true}
              paginationVariant="hidden"
            >
              {logos &&
                logos.length >= 6 &&
                logos.map(({ logo }: any, idx: number) => {
                  return (
                    <SwiperSlide key={`partner-logos-slider--${idx}`}>
                      <PartnerItem
                        imgUrl={logo.url}
                        alt={logo?.alt || 'Partner Logo'}
                      />
                    </SwiperSlide>
                  );
                })}
            </Carousel>
          </div>
        </Grid>
      </div>
    </Container>
  );
}
